import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing(6)};

  & svg {
    fill: ${({ theme }) => theme.colors.night_blue_2};
  }
`;

export default Content;
